import { Component, Input, OnInit } from '@angular/core';
import { Params } from '@angular/router';
import { Flags } from 'src/app/components/shared/types/flags.type';

@Component({
  selector: 'app-mu-alert-modal-dialog',
  templateUrl: './mu-alert-modal-dialog.component.html',
  styleUrls: ['./mu-alert-modal-dialog.component.sass'],
})
export class MuAlertModalDialogComponent<FlagType> implements OnInit {
  /**
   * icon of the dialog
   */
  @Input() icon: string;
  /**
   * Dialog title
   */
  @Input() title: string;
  /**
   * Message
   */
  @Input() message: string;
  /**
   * show modal flag
   */
  @Input() showFlag: FlagType;
  /**
   * action modal flag
   */
  @Input() actionFlag: FlagType;
  /**
   * show loader flag
   */
  @Input() loaderFlag: FlagType;
  /**
   * flag list
   */
  @Input() flagList: Flags<FlagType>;
  /**
   * font size 14px for buttons
   */
  @Input() buttonSlim: boolean;
  /**
   * custom label for button action
   */
  @Input() buttonMainActionLabel: string;
  /**
   * custom cancel label for button action
   */
  @Input() buttonCancelLabel: string;
  /**
   * custom redirect link to cancel button
   */
  @Input() buttonCancelLink: string;
  /**
   * custom redirect link to cancel button
   */
  @Input() queryParametersCancelLink?: Params;
  constructor() {
    /** */
  }

  ngOnInit(): void {
    /** */
  }
}
